import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
export const donutChartDataLabelFormatter = (context, displayKind, displayValueType) => {
    let display = "";
    switch (true) {
        case displayKind === ChartSelectValueFormatKind.percent:
            display = numberFormatters(context.y, NumberFormatKind.percent, { maximumSignificantDigits: 3 });
            break;
        case displayValueType === DisplayValueType.Percent:
            display = numberFormatters(context.percentage / 100, NumberFormatKind.percent, { maximumFractionDigits: 2 });
            break;
        case displayKind === ChartSelectValueFormatKind.value:
            display = numberFormatters(context.y, NumberFormatKind.compact);
            break;
        case displayKind === ChartSelectValueFormatKind.multiple:
            display = numberFormatters(context.y, NumberFormatKind.multiple);
            break;
        default:
            display = numberFormatters(context.y, NumberFormatKind.compact, { maximumFractionDigits: 2 });
    }
    return `<div class="labelName">${context.key}</div><div class="labelValue">
                        ${display}
                        </div>`;
};
